import { createSlice } from "@reduxjs/toolkit";

const refreshFileManagerSlice = createSlice({
  name: "refreshFileManager",
  initialState: false,
  reducers: {
    setRefreshFileManager: (_state, action) => action.payload,
  },
});

const selectedFilesSlice = createSlice({
  name: "selectedFiles",
  initialState: [],
  reducers: {
    setSelectedFiles: (_state, action) => action.payload,
  },
});

const currentFolderSlice = createSlice({
  name: "currentFolder",
  initialState: null,
  reducers: {
    setCurrentFolder: (_state, action) => {
      return action.payload ? { ...action.payload } : null;
    },
    emptyCurrentFolder: () => null,
  },
});

const fileManagerBreadCrumbSlice = createSlice({
  name: "fileManagerBreadCrumb",
  initialState: [],
  reducers: {
    setFileManagerBreadCrumbData: (_state, action) => action.payload,
  },
});

export const { setRefreshFileManager } = refreshFileManagerSlice.actions;
export const { setSelectedFiles } = selectedFilesSlice.actions;
export const { setCurrentFolder, emptyCurrentFolder } = currentFolderSlice.actions;
export const { setFileManagerBreadCrumbData } = fileManagerBreadCrumbSlice.actions;

export const refreshFileManager = refreshFileManagerSlice.reducer;
export const selectedFiles = selectedFilesSlice.reducer;
export const currentFolder = currentFolderSlice.reducer;
export const fileManagerBreadCrumb = fileManagerBreadCrumbSlice.reducer;
